import * as api from 'security/resources/security.api';
import myAccountConfirmTemplate from './my-account-form.html';

const MODE_EDIT = 'edit';
const MODE_CONFIRM = 'confirm';
const DIRTY_FORM = 'myAccount';

const mapStateToThis = ({ session, config }) => {
  const { isAdmin, locale } = session;
  const { phoneMask, phoneLength, maxFirstNameLength, maxLastNameLength, maxEmailLength, passwordErrorText } = config;
  const passwordRequirementText = passwordErrorText ? passwordErrorText[locale] : '';

  return {
    locale,
    isAdmin,
    phoneMask,
    phoneLength,
    maxFirstNameLength,
    maxLastNameLength,
    maxEmailLength,
    passwordRequirementText,
  };
};

// eslint-disable-next-line no-undef
@Inject('$ngRedux', '$state')
class MyAccountFormController {
  constructor() {
    this.unsubscribe = this.$ngRedux.connect(mapStateToThis, null)(this);
  }

  async $onInit() {
    this.DIRTY_FORM = DIRTY_FORM;
    this.initializeConfiguration();
    this.securityQuestions = await api.fetchSecurityQuestions();
  }

  $onDestroy() {
    this.unsubscribe();
  }

  initializeConfiguration() {
    this.securityAnswerPlaceholder = ['••••••••', '••••••••'];
    this.mode = MODE_EDIT;
  }

  submit(form) {
    form.$setSubmitted();
    if (form.$invalid) {
      return;
    }

    this.setConfirmMode();
  }

  handleUserConfirmation(form) {
    this.submitConfirm().then(() => {
      this.setEditMode();
      this.resetForm(form);
    });
  }

  resetForm(form) {
    form.$setPristine();
    form.$setUntouched();
    this.user.password = undefined;
    this.user.confirmPassword = undefined;
  }

  isEditMode() {
    return this.mode === MODE_EDIT;
  }

  isConfirmMode() {
    return this.mode === MODE_CONFIRM;
  }

  setEditMode() {
    this.mode = MODE_EDIT;
  }

  setConfirmMode() {
    this.mode = MODE_CONFIRM;
  }

  onPasswordChange() {
    this.user.confirmPassword = '';
  }

  onSecurityQuestionChange(id) {
    this.user.securityQuestions[id].answer = '';
    this.securityAnswerPlaceholder[id] = '';
  }

  cancel() {
    this.$state.go(this.$state.previous);
  }
}

export default class MyAccountFormComponent {
  constructor() {
    this.template = myAccountConfirmTemplate;
    this.controller = MyAccountFormController;
    this.bindings = {
      user: '<',
      submitConfirm: '&',
    };
    return this;
  }
}



// WEBPACK FOOTER //
// ./src/modules/user/components/my-account/components/form/my-account-form-component.js